// Phase P.3 Item 3 — reusable manual refresh button for page headers.
//
// Consumers pass an async `onRefresh` that re-fetches the page's primary
// data. The button spins for the duration of the in-flight promise and
// disables itself so double-clicks don't cascade. Deliberately unstyled
// beyond the icon + size so it drops into any toolbar without conflict.

import { useState } from "react";
import { RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";

export function PageRefreshButton({
  onRefresh,
  variant = "outline",
  size = "sm",
  label = "Refresh",
  showLabel = false,
  className = "",
  testId = "page-refresh-btn",
}) {
  const [spinning, setSpinning] = useState(false);
  const handleClick = async () => {
    if (spinning) return;
    setSpinning(true);
    try {
      await onRefresh();
    } catch (e) {
      // Callers should surface their own toasts. Swallow here so the button
      // still resets cleanly on failure.
    } finally {
      setSpinning(false);
    }
  };
  return (
    <Button
      variant={variant}
      size={size}
      onClick={handleClick}
      disabled={spinning}
      className={`gap-1.5 ${className}`}
      title={label}
      data-testid={testId}
    >
      <RefreshCw className={`h-4 w-4 ${spinning ? "animate-spin" : ""}`} />
      {showLabel && <span>{spinning ? "Refreshing…" : label}</span>}
    </Button>
  );
}

export default PageRefreshButton;
